import React from 'react';
import '../less/faq.less';
import Qna from '../views/qna';

export default function template() {
    const {shortModeLength, questions} = this.props,
        questionsToRender = this.state.fullMode ? questions : questions.slice(0, shortModeLength),
        faqQuestions = questionsToRender.map((item, index) => <Qna data={item} key={index} />),
        toggler =
            questions.length > shortModeLength ? (
                <span onClick={this.toggleFAQMode}>
                    {this.state.fullMode ? this.l10n('FAQ_HIDE') : this.l10n('FAQ_SHOW_MORE')}
                </span>
            ) : null;

    return (
        <div className="faq">
            <div id="question-block">{faqQuestions}</div>
            <div className="faq-mode-toggler">{toggler}</div>
        </div>
    );
}
